module.exports = __webpack_public_path__ + "static/media/world-primary.26a77210.svg";